export default __webpack_public_path__ + "assets/cleankitchen-mealkit/dan_dan_noodle.0e70969a24345086f04c038857638ced.webp";